import { createReducer, on } from '@ngrx/store';
import * as UigAccessSubjectActions from './uig-access-subject.action';
import { AccessSubjectList } from './uig-access-subject.model';

export const uigAccessSubjectFeatureKey = 'uigAccessSubject';

export const UIG_ACCESS_SUBJECT_OVERVIEW = 'uigAccessSubjectOverview';

export interface UigAccessSubjectState {
  [UIG_ACCESS_SUBJECT_OVERVIEW]: {
    uigAccessSubjectOverview: AccessSubjectList;
    isLoading: boolean;
    error?: Error;
  };
}

export const initialState: UigAccessSubjectState = {
  [UIG_ACCESS_SUBJECT_OVERVIEW]: {
    uigAccessSubjectOverview: null,
    isLoading: false,
    error: null,
  }
}

export const uigAccessSubjectReducer = createReducer(
  initialState,
  on(UigAccessSubjectActions.getUigAccessSubjectOverview,
    (state) => ({
      ...state,
      [UIG_ACCESS_SUBJECT_OVERVIEW]: {
        uigAccessSubjectOverview: null,
        isLoading: true,
        error: null,
      },
    })),
  on(UigAccessSubjectActions.getUigAccessSubjectOverviewSuccess,
    (state, action) => ({
      ...state,
      [UIG_ACCESS_SUBJECT_OVERVIEW]: {
        uigAccessSubjectOverview: action.uigAccessSubjectOverview,
        isLoading: false,
        error: null,
      },
    })
  ),
  on(UigAccessSubjectActions.getUigAccessSubjectOverviewFailure,
    (state, action) => ({
      ...state,
      [UIG_ACCESS_SUBJECT_OVERVIEW]: {
        uigAccessSubjectOverview: null,
        isLoading: false,
        error: action.error,
      },
    })
  ),
);
